<template>
  <div class="doc-section">
    <span class="type-title">
      待办
      <i>
        (共
        <em>{{length}}</em> 条记录)
      </i>
      <look-more v-if="hideContent && alloverflow" type="todo" />
    </span>
    <div
      :class="{'data-view':true,'view-over':!hideContent}"
      v-for="(section,index) in currentData"
      :key="index"
      :style="{order:searchResultWeight[section.title]}"
    >
      <div>
        <p>
          <span
            :class="{'section-title':true,'bg-pink':section.title==='审批中心','bg-pruple':section.title==='会议','bg-orange':section.title==='工单','bg-yellow':section.title==='个人待办' }"
          >{{section.title}}</span>
          <i class="record-length">
            (共
            <em>{{parseInt(lengthMap[section.title]||0)}}</em> 条记录)
          </i>
          <look-more v-if="hideContent && section.items.length>max" :type="section.title" />
        </p>
        <a
          v-for="(i,n) in (hideContent ? section.items.slice(0,max):section.items)"
          :key="n"
          class="result-item"
          :href="i.url"
          target="_blank"
          v-high-light="{key:$route.params.key,content:i.title}"
        >{{i.title}}</a>
      </div>
    </div>
    <el-pagination
      v-if="!hideContent"
      :total="length"
      layout="prev, pager, next"
      :page-size="pageSize"
      @current-change="handleCurrentChange"
    ></el-pagination>
  </div>
</template>
<script>
import lookMore from "./look-more";
import mixinsPagination from "@/mixins/pagination";

export default {
  name: "todo-section",
  mixins: [mixinsPagination],

  components: { lookMore },
  props: {
    sectionData: Array,
    hideContent: {
      type: Boolean,
      default: true
    },
    max: {
      type: Number,
      default: 3
    }
  },

  data: function() {
    return {
      length: 0,
      alloverflow: false,
      pageSize: 16,
      searchResultWeight: {
        审批中心: 1,
        会议: 2,
        工单: 3,
        个人待办: 4
      }
    };
  },
  computed: {
    activeSectionData: function() {
      const { type } = this.$route.params;
      return this.sectionData.filter(item =>
        type && type !== "todo" ? item.title == type : true
      );
    }
  }
};
</script>
<style lang="scss" scoped>
.doc-section {
  .data-view {
    margin-top: 10px;
    padding: 20px 20px 0;
    display: flex;
    flex-direction: column;
    border: 1px solid rgba(237, 237, 237, 1);
  }
  .section-title {
    color: #ffffff;
    width: 80px;
    height: 24px;
    font-size: 14px;
    line-height: 24px;
    display: inline-block;
    text-align: center;
  }
  .bg-pink {
    background-image: linear-gradient(to right, #f9a3ca, #ff788e);
  }
  .bg-pruple {
    background-image: linear-gradient(to right, #db9fef, #ac86d5);
  }
  .bg-yellow {
    background-image: linear-gradient(to right, #ffa97c, #ff885c);
  }
  .bg-orange {
    background-image: linear-gradient(to right, #ffc850, #ffad50);
  }

  .record-length {
    color: rgba(143, 149, 172, 1);
    font-size: 12px;
    font-weight: normal;
    margin-left: 6px;
  }
}
</style>
